module.exports = __webpack_public_path__ + "img/dialogBlue.38dfeab6.png";